<template lang="pug">
section
  .container
    .row
      breadcrumb
    .row
      .col-12.text-center
        h2.title.i_mt_19.i_mt_md_10 榮耀肯定
  media-img.golden_line_up.i_mt_6(:imgUrl="'golden_line_up'")
  .container.list.i_mt_2
    .row
      .col-12(v-for="(honors, index) in currentCompanyHonorList", :key="index")
        honor(:honors="honors")
    .row.i_mt_8
      .col-12.text.center.justify-content-center
        b-pagination(
          v-model="currentPage",
          :total-rows="totalRows",
          :per-page="perPage",
          first-number,
          last-number
        )
</template>

<script>
import MediaImg from "@/components/common/MediaImg";
import Honor from "@/components/about_us/profile/Honor";
import { getCompanyHonor } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "AboutUsProfileHonor",
  metaInfo() {
    return {
      title: this.companyHonor.SEO_Title,
      meta: [
        { name: "description", content: this.companyHonor.SEO_Description },
      ],
    };
  },
  components: {
    "media-img": MediaImg,
    honor: Honor,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      companyHonor: {},
      currentCompanyHonorList: [],
      totalRows: 0,
      perPage: 4,
      currentPage: 1,
    };
  },
  created() {
    this.getCompanyHonor();
  },
  watch: {
    currentPage() {
      this.getCurrentList();
    },
  },
  methods: {
    getCompanyHonor() {
      getCompanyHonor().then((response) => {
        this.companyHonor = response.data;
        this.totalRows = this.companyHonor.CompanyHonorList.length;
        this.getCurrentList();
      });
    },
    getCurrentList() {
      this.currentCompanyHonorList = [];
      let number = this.perPage * this.currentPage;
      this.currentCompanyHonorList = this.companyHonor.CompanyHonorList.slice(
        number - this.perPage,
        number
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/pagination";
@import "@/assets/style/about_us/honor";
</style>
